export type PathNavItem = {
  id: string;
  title: string;
};

export const PATH_NAV_ITEMS: PathNavItem[] = [
  {
    id: 'overview',
    title: 'Overview',
  },
  {
    id: 'how-it-works',
    title: 'How It Works',
  },
  {
    id: 'data-privacy',
    title: 'Data Privacy & Security',
  },
  {
    id: 'getting-started',
    title: 'Get Started Today',
  },
];
